import React from 'react';
import { useTranslation } from 'react-i18next';

import useLinesHelper from '../../helpers/useLinesHelper';

interface MobileQuickPickButtonProps {
    linesPrice: string;
    quickPickLines: number;
}

function MobileQuickPickButton({ linesPrice, quickPickLines }: MobileQuickPickButtonProps) {
    const { t } = useTranslation();
    const { multipleQuickPick } = useLinesHelper();

    return (
        <div className="row no-gutters play-button">
            <div className="col">
                <button
                    type="button"
                    className="btn btn-primary d-block quick-pick-lines"
                    onClick={() => multipleQuickPick(quickPickLines)}
                >
                    <div>
                        {quickPickLines} {t('playPicker.quickPickLines')}
                        <small>{`(${linesPrice})`}</small>
                    </div>
                </button>
            </div>
        </div>
    );
}

export default MobileQuickPickButton;
